module.exports = __webpack_public_path__ + "static/media/exit.ead0da35.svg";